export default __webpack_public_path__ + "static/media/3.1327c157.png";